import { NgModule } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { environment } from '@environments/environment';
import { HttpLoggingInterceptor } from '@services/logging/http-logging.interceptor';
import { Logger, LogInfo } from '@services/logging/logger';
import { LoggingService } from '@services/logging/logging.service';
import { Log } from 'ng2-logger/browser';

@NgModule({
    providers: [
        LoggingService
    ]
})
class LoggingModule {

    constructor(private router: Router) {
        this.configure();
    }

    private configure() {
        this.configureSinks();
        this.configureRouterSink();
    }

    private configureSinks() {
        const appLog: Log = Log.create(environment.logger.sinks.application.name, ...environment.logger.sinks.application.levels);
        const authog: Log = Log.create(environment.logger.sinks.auth.name, ...environment.logger.sinks.auth.levels);
        const httpLog: Log = Log.create(environment.logger.sinks.http.name, ...environment.logger.sinks.http.levels);
        const routerLog: Log = Log.create(environment.logger.sinks.router.name, ...environment.logger.sinks.router.levels);
        const storeLog: Log = Log.create(environment.logger.sinks.store.name, ...environment.logger.sinks.store.levels);

        Logger.addLog(environment.logger.sinks.application.name, appLog, true);
        Logger.addLog(environment.logger.sinks.auth.name, authog, false);
        Logger.addLog(environment.logger.sinks.http.name, httpLog, false);
        Logger.addLog(environment.logger.sinks.router.name, routerLog, false);
        Logger.addLog(environment.logger.sinks.store.name, storeLog, false);
    }

    private configureRouterSink() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                Logger.sinks[environment.logger.sinks.router.name].debug('START', event, (event as any).url);
            } else if (event instanceof NavigationEnd) {
                Logger.sinks[environment.logger.sinks.router.name].info('END', event, (event as any).url);
            } else if (event instanceof NavigationCancel) {
                Logger.sinks[environment.logger.sinks.router.name].warn('CANCEL', event, (event as any).url);
            } else if (event instanceof NavigationError) {
                Logger.sinks[environment.logger.sinks.router.name].error('ERROR', event, (event as any).url);
            } else if (event instanceof RoutesRecognized) {
                Logger.sinks[environment.logger.sinks.router.name].debug('RECOGNIZED', event, (event as any).url);
            }
        });

        Logger.sinks[environment.logger.sinks.router.name].info('CONFIG', 'subscribed');
    }
}

export { LoggingModule, Logger, LogInfo, LoggingService, HttpLoggingInterceptor };
